/**
 * wyvio-ui · VehicleThumb + WorkflowProgress
 * ──────────────────────────────────────────
 * ADN automobile : composants transverses aux pages produit.
 */

/**
 * Vignette véhicule. Photo si `src`, sinon silhouette wyvio SVG.
 * Ratio 5:4. Radius 12 px. Bordure ultra-fine.
 */
export const VehicleThumb = ({ src, alt, size = 56, className = "" }) => {
  const box = { width: size, height: Math.round(size * 0.75) };
  return (
    <div
      style={box}
      className={[
        "relative shrink-0 overflow-hidden rounded-xl",
        "bg-[#F3F4F6] dark:bg-[#1A1A1A]",
        "border border-[#EEF2F5] dark:border-[#262626]",
        className,
      ].join(" ")}
      aria-hidden={!alt}
    >
      {src ? (
        <img
          src={src}
          alt={alt || ""}
          className="absolute inset-0 h-full w-full object-cover"
          loading="lazy"
        />
      ) : (
        <svg
          viewBox="0 0 64 48"
          className="absolute inset-0 h-full w-full text-[#D1D5DB] dark:text-[#3A3A3A]"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinejoin="round"
          strokeLinecap="round"
        >
          <path d="M6 33 L10 22 C12 18 15 16 20 16 L44 16 C49 16 52 18 54 22 L58 33" />
          <path d="M4 33 H60 V38 C60 39 59 40 58 40 H52 C51 40 50 39 50 38 V37 H14 V38 C14 39 13 40 12 40 H6 C5 40 4 39 4 38 Z" />
          <circle cx="17" cy="37" r="3" />
          <circle cx="47" cy="37" r="3" />
        </svg>
      )}
    </div>
  );
};

/**
 * Progress bar Tesla-style : N segments alignés.
 * - completed : blanc/foncé plein
 * - active    : lime pulse
 * - upcoming  : gris tissé
 */
export const WorkflowProgress = ({ steps = [], activeIndex = -1, className = "" }) => {
  return (
    <div
      className={["flex items-center gap-1", className].join(" ")}
      aria-label="Progression du dossier"
      data-testid="wyvio-progress"
    >
      {steps.map((s, i) => {
        const done = s.status === "termine";
        const blocked = s.status === "bloque";
        const active = i === activeIndex && !done;
        const cls = blocked
          ? "bg-[#EF4444]"
          : done
          ? "bg-[#0A0A0A] dark:bg-white"
          : active
          ? "bg-[#C8FF2F] animate-pulse"
          : "bg-[#EEF2F5] dark:bg-[#262626]";
        return (
          <span
            key={s.key || i}
            title={s.label || s.title}
            className={["h-1 flex-1 rounded-full transition-colors duration-300", cls].join(" ")}
          />
        );
      })}
    </div>
  );
};
